import { isUrlHttp, changeRef } from '@/utils/location';
import dynamicClass from 'clsx';
import { useContext, useEffect, useState } from 'react';
import GlobalContext from '../../../contexts/globalContext';
import UseTraceItemShipping from '../../../hooks/useTraceItemShipping';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import { normalizeWords } from '../../../utils/normalizeWords';
import Tooltip from '../tooltip/tooltip';
import circle from '../../../assets/images/icons/circle.svg';
import useMobile from '@/hooks/useMobile';
import './submenuElement.scss';

const SubmenuElement = ({
    item,
    index,
    subOption,
    bold,
    tooltipLeft,
    gtm = '',
    traceLabel,
    isIcon = true,
    isTitle = false,
    haveChild,
    onlyRedirection,
    selectedChild,
    crossIcon = false,
}: any) => {
    const { gigyaContext, userInfoContext } = useContext(GlobalContext);
    const { window, localStorage, isBrowser } = useBrowserMode();
    const [pageLoad, setPageLoad] = useState(false);

    const mobile = useMobile();

    useEffect(() => {
        if (
            gigyaContext.gigyaAccount &&
            localStorage?.getItem('menuRedirect')
        ) {
            const storage: any = localStorage?.getItem('menuRedirect');
            localStorage?.removeItem('menuRedirect');
            const redirect = JSON.parse(storage);
            openRedirect(redirect.href);
        }
    }, [gigyaContext.gigyaAccount]);

    const loginAndRedirect = (redirect) => {
        localStorage?.setItem(
            'menuRedirect',
            JSON.stringify({ href: redirect })
        );
        gigyaContext.login();
    };

    const openRedirect = (redirect) => {
        if (!redirect) return;
        window.open(
            changeRef(redirect),
            isUrlHttp(redirect) ? '_blank' : '_self'
        );
    };

    useEffect(() => {
        setPageLoad(true);
    }, []);

    const classSubMenu = dynamicClass('a-submenu-element', {
        'a-submenu-element--bold': bold,
        'a-submenu-element--icon': isIcon,
        'a-submenu-element--title': isTitle,
        'a-submenu-element--subOption': subOption,
        [`gtmHomePersonasClic${
            gtm.includes('tr') ? 'Servicios' : 'ConoceComfama'
        }`]: isBrowser && localStorage?.getItem('CURRENT_TAB') === 'personas',
        [`gtmHomeEmpresasClicSubmenu${
            gtm.includes('tr') ? 'Servicios' : 'ConoceComfama'
        }`]: isBrowser && localStorage?.getItem('CURRENT_TAB') === 'empresas',
    });

    const onTraceItemShipping = () => {
        !gigyaContext.gigyaAccount && item.lockedIcon
            ? loginAndRedirect(item.redireccion)
            : !bold && openRedirect(item.redireccion);
        if (!gigyaContext?.gigyaAccount) return;
        UseTraceItemShipping(
            gigyaContext?.gigyaAccount?.profile.firstName +
                ' ' +
                (gigyaContext.gigyaAccount.data.secondName
                    ? gigyaContext.gigyaAccount.data.secondName + ' '
                    : '') +
                gigyaContext.gigyaAccount.profile.lastName +
                (gigyaContext.gigyaAccount.data.secondLastName
                    ? ' ' + gigyaContext.gigyaAccount.data.secondLastName
                    : ''),
            gigyaContext?.gigyaAccount?.data.docNumber,
            gigyaContext?.gigyaAccount?.data.docType,
            gigyaContext?.gigyaAccount?.profile.email,
            'redirection',
            traceLabel || normalizeWords(item.nombre),
            userInfoContext.data?.userJwt
        );
    };

    return (
        <>
            {onlyRedirection ? (
                <div
                    className="a-submenu-element--simpleLine"
                    onClick={() => {
                        onTraceItemShipping();
                    }}
                >
                    <img src={circle} alt="Icono Lista" title="Icono Lista" />
                    <a
                        className={classSubMenu}
                        key={`submenu-${index}`}
                        rel="noopener noreferrer"
                        title={item.nombre}
                    >
                        <p>{item.nombre}</p>
                        {!mobile && <span>{item.subtitulo}</span>}
                    </a>
                </div>
            ) : (
                <div
                    className="a-submenu-element--line"
                    onClick={() => {
                        onTraceItemShipping();
                    }}
                >
                    {pageLoad && (
                        <a
                            className={classSubMenu}
                            key={`submenu-${index}`}
                            rel="noopener noreferrer"
                            aria-label={item.nombre}
                        >
                            <p>{item.nombre}</p>
                            {!mobile && <span>{item.subtitulo}</span>}
                        </a>
                    )}
                    {item.interrogationIcon && isIcon && (
                        <Tooltip
                            tooltipLeft={tooltipLeft}
                            content={item.interrogationDescription?.raw}
                        />
                    )}
                    {item.lockedIcon && !gigyaContext.gigyaAccount && (
                        <img
                            className="a-submenu-element__lock"
                            src={item.iconoCandado.file.url}
                            alt={item.iconoCandado.file.url + 'Icono bloqueado'}
                            title={
                                item.iconoCandado.file.url + 'Icono bloqueado'
                            }
                        />
                    )}
                    {haveChild && !crossIcon && (
                        <i
                            className={`icon-angle-right ${
                                selectedChild ? 'icon__selected' : ''
                            }`}
                            title="flecha-a-la-derecha"
                        />
                    )}
                    {haveChild && crossIcon && (
                        <span
                            className={`a-submenu-element__btn-icon ${
                                selectedChild
                                    ? 'a-submenu-element__btn-icon--active'
                                    : ''
                            }`}
                        ></span>
                    )}
                </div>
            )}
        </>
    );
};

export default SubmenuElement;
